import { StrictMode, type ReactNode } from 'react';
import { createRoot } from 'react-dom/client';
import { AuthGate } from './auth/AuthGate.js';
import { Enroll } from './auth/Enroll.js';
import { App } from './app/App.js';
import { getRuntime } from './runtime/runtime.js';
import { setupServiceWorker } from './app/pwa.js';
import './styles/app.css';

// Phase 5: the gate resolves the session and creates the mission runtime only once the device is
// approved. `/e` is the QR enrolment landing page (token in the URL fragment). A legacy `?role=`
// query keeps the Phase 3/4 dev-identity path (the spike page and the existing e2e rely on it).
const isEnroll = location.pathname === '/e' || location.pathname === '/e/';
const devRole = new URLSearchParams(location.search).get('role');

function Root(): ReactNode {
  if (isEnroll) return <Enroll />;
  if (devRole) return <App />; // dev identity resolved from the URL by getRuntime()
  return <AuthGate />;
}

if (devRole && !isEnroll) {
  const rt = getRuntime();
  rt.start();
  setupServiceWorker(rt);
}

createRoot(document.getElementById('app') as HTMLElement).render(
  <StrictMode>
    <Root />
  </StrictMode>,
);
